// ©2024 Austin App House. All rights reserved.
import React from 'react';
import Select from '../../layout/CustomSelect';
import { dashboardSearchable, dashboardSelectClassNames } from '../../../utils/customSelectStyle';

const SelectMessageRecipients = ({
    companyMembers,
    activeTab,
    selectedUsers,
    setSelectedUsers,
    isForContractor,
    setIsNeedSendToContractor
}) => {
    const handlerOnChange = ({ value, name }) => {
        switch (name) {
            case 'selectedCompanyUsers': setSelectedUsers(value || []); break;
            case 'isNeedSendToContractor': setIsNeedSendToContractor(value); break;
            // case 'selectedApplicants': setSelectedApplicants(value || []); break;
        }
    }

    return (
        <>
            <div className="field_row">
                <div className="field_name">
                    <label htmlFor="bulk_message_company_users">Company User(s)</label>
                </div>
                <div className="field_block dashboard-select-wrap">
                  <Select
                    inputId="bulk_message_company_users"
                    isClearable
                    isSearchable
                    isMulti
                    closeMenuOnSelect={false}
                    options={companyMembers}
                    value={selectedUsers}
                    styles={dashboardSearchable}
                    classNames={dashboardSelectClassNames}
                    onChange={value => handlerOnChange({ name: 'selectedCompanyUsers', value })}
                  />
                </div>
            </div>
        </>
    );
};

export default SelectMessageRecipients;
